import owd from 'owd/owd';
import debounce from 'lodash/debounce';

export default class RealtimeSearch extends owd.Component {
	init() {
        this.bind();
        this.doQuery = debounce(this.doQuery, 300);

        this.$element.find('input[autofocus]')[0].select();
        this.$element.find('input[autofocus]').focus();
	}

	bind() {
        this.on('keyup keydown change', 'input', (e) => {
            if (e.currentTarget.value != this.currentValue && (
                e.currentTarget.value.length >= 3 || (
                    e.currentTarget.value.length == 0 && this.currentValue.length > 0
                )
                )) {
                this.currentValue = e.currentTarget.value;
                this.doQuery();
            }
        });
        
        this.on('submit', (e) => {
            e.preventDefault();
            this.doQuery();
        });
    }

    doQuery() {
        if (this.xhr && this.xhr.abort) {
            this.xhr.abort();
        }

        const $results = $('[data-realtime-search-results]');
        $results.addClass('is-loading');

        this.xhr = $.ajax({
            url: this.$element.attr('action'),
            method: 'get',
            dataType: 'html',
            data: {
                s: this.$element.find('[name=s]').val()
            }
        });
        
        this.xhr.then(response => {
            this.xhr = undefined;

            const $tmp = $('<html>').html(response);
            
            $results.children().trigger('destroy').remove();
            $results.html($tmp.find('[data-realtime-search-results]').html());
            $results.removeClass('is-loading');
            
            this.app.tick($results);

            history.replaceState({
                ...history.state
            }, $('title').text(), this.$element.attr('action') + '?s=' + this.$element.find('[name=s]').val());
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('realtime-search', {
	component: RealtimeSearch
});
